import React from 'react';
import { ShopifyIcon } from 'tuui/lib/atoms/Icon/Icons';
import { defaultMessages } from '../../taboola-common-frontend-modules/i18n/config/messages';
import { Woocommerce } from '../icons/Woocommerce';
import { Wordpress } from '../icons/Wordpress';

export const THIRD_PARTY_PLATFORM = {
    WORDPRESS: 'wp',
    SHOPIFY: 'shopify',
    WOOCOMMERCE: 'wc',
};

const PLATFORM_CONFIG = {
    [THIRD_PARTY_PLATFORM.WORDPRESS]: {
        name: 'Wordpress',
        icon: Wordpress,
    },
    [THIRD_PARTY_PLATFORM.SHOPIFY]: {
        name: 'Shopify',
        icon: () => <ShopifyIcon width={40} height={40} color="#95BF46" />,
    },
    [THIRD_PARTY_PLATFORM.WOOCOMMERCE]: {
        name: 'Woocommerce',
        icon: Woocommerce,
    },
};

export const getPlatformName = platformCode => {
    return PLATFORM_CONFIG[platformCode]?.name || defaultMessages['3p-connect.default.platform'] || 'Your';
};

export const getPlatformIcon = platformCode => {
    return PLATFORM_CONFIG[platformCode]?.icon || Wordpress;
};
